import { render } from "./VueRecaptchaEnterprise.vue?vue&type=template&id=26671972&scoped=true"
import script from "./VueRecaptchaEnterprise.vue?vue&type=script&lang=js"
export * from "./VueRecaptchaEnterprise.vue?vue&type=script&lang=js"

import "./VueRecaptchaEnterprise.vue?vue&type=style&index=0&id=26671972&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src298404285/src/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26671972"],['__file',"src/components/VueRecaptchaEnterprise.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26671972"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26671972', __exports__)) {
    console.log('reload')
    api.reload('26671972', __exports__)
  }
  
  module.hot.accept("./VueRecaptchaEnterprise.vue?vue&type=template&id=26671972&scoped=true", () => {
    console.log('re-render')
    api.rerender('26671972', render)
  })

}


export default __exports__